const comissionListPopReducers = (state = false, action) => {
  switch (action.type) {
    case "openComissionListPop":
      return (state = true);
    case "closeComissionListPop":
      return (state = false);
    default:
      return state;
  }
};
export default comissionListPopReducers;
